import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  CreditCardDirectivesModule,
  CreditCardValidators,
} from "angular-cc-library";

import { API_URLS } from "../../../config/app.constants";

import { NgFor, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { NgbModal, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { LaddaModule } from "angular2-ladda";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import swal from "sweetalert2";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
declare var $: any;

@Component({
  selector: "app-card-list",
  templateUrl: "./card-list.component.html",
  styleUrls: ["./card-list.component.scss"],
  standalone: true,
  imports: [
    RouterLink,
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    CreditCardDirectivesModule,
    LaddaModule,
    NgbTooltipModule,
  ],
})
export class CardListComponent implements OnInit {
  cards = [];
  filteredCard = [];
  isCardAdding: boolean = false;
  cardType: string;
  submittedNewCard: boolean = false;

  addCardFormData: any = {
    cc_exp_month: "",
    cc_exp_year: "",
    cc_csc: "",
    cc_number: "",
    cc_holder_name: "",
    is_default: false,
  };
  addCreditCardForm = new FormGroup({
    cc_holder_name: new FormControl("", [Validators.required]),
    card_number: new FormControl("", [
      Validators.required,
      CreditCardValidators.validateCCNumber,
    ]),
    card_expiry: new FormControl("", [
      Validators.required,
      CreditCardValidators.validateExpDate,
    ]),
    card_cvv: new FormControl("", [Validators.minLength(3)]),
    is_default: new FormControl(false, []),
  });
  selectedCard = "";
  selectedCardDetail: any;

  constructor(
    private http: HttpinterceptorService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getCardList();
  }

  getCardList() {
    this.http.post(API_URLS.GET_CARD, {}, false).subscribe((res) => {
      if (res.data) {
        this.cards = res.data;
      }
    });
  }

  saveNewCreditCard() {
    this.submittedNewCard = true;
    if (this.addCreditCardForm.valid) {
      this.isCardAdding = true;
      const month = this.addCreditCardForm.value.card_expiry.split("/");
      this.addCardFormData.cc_number =
        this.addCreditCardForm.value.card_number.replace(/\s/g, "");
      this.addCardFormData.cc_exp_month = $.trim(month[0]);
      this.addCardFormData.cc_exp_year = $.trim(month[1]);
      this.addCardFormData.cc_csc = this.addCreditCardForm.value.card_cvv;
      this.addCardFormData.cc_holder_name =
        this.addCreditCardForm.value.cc_holder_name;
      this.addCardFormData.is_default = this.addCreditCardForm.value.is_default
        ? 1
        : 0;

      this.http.post(API_URLS.ADD_CARD, this.addCardFormData, true).subscribe(
        (res) => {
          this.isCardAdding = false;
          if (res.code == "200" && res.type === "success") {
            this.addCreditCardForm.reset();
            // $(".error").remove("label");
            this.closeModalContent();
            this.getCardList();
          }
        },
        (error) => {
          this.isCardAdding = false;
          return false;
        }
      );
    } else {
      this.addCreditCardForm.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return false;
    }
  }

  scrollToFirstInvalidControl() {
    let form = document.getElementById("add_new_credit_card_form"); // <-- your formID
    let firstInvalidControl = form.getElementsByClassName("ng-invalid")[0];
    firstInvalidControl.scrollIntoView();
    (firstInvalidControl as HTMLElement).focus();
  }

  // getCardType() {
  //   let cardType;
  //   let card;
  //   $('.card_number').validateCreditCard(function (result) {
  //     if (result.card_type !== null) {
  //       cardType = result.card_type.name + '.png';
  //       card = result.card_type.name;
  //     }
  //   });
  //   this.cardType = cardType;
  //   this.addCreditCardForm.value.cc_type = card;
  // }

  openAddCardModal(content) {
    this.addCreditCardForm.reset();
    this.submittedNewCard = false;
    this.openModalContent(content);
  }

  openConfirmationPopup(content, cardDetail) {
    this.selectedCardDetail = cardDetail;
    if (
      this.selectedCardDetail.is_default &&
      this.cards &&
      this.cards.length > 1
    ) {
      this.filteredCard = JSON.parse(JSON.stringify(this.cards));
      this.filteredCard = this.filteredCard.filter((card) => !card.is_default);
      this.openModalContent(content);
    } else if (!this.selectedCardDetail.is_default) {
      swal
        .fire({
          title: "Remove",
          text: "Are You Sure Want to Remove this Card?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Remove it!",
          cancelButtonText: "No, keep it",
        })
        .then((result) => {
          if (result.value) {
            /* if (cardDetail.is_default) {
              $(".change-card-modal").modal("toggle");
            } else {
              this.removeCard(cardDetail);
            } */
            this.removeCard(cardDetail);
          }
        });
    }
  }

  removeCard(cardDetail) {
    this.http
      .post(
        API_URLS.REMOVE_CARD,
        {
          set_default_card_id: this.selectedCard ? this.selectedCard : "",
          credit_card_id: cardDetail.id,
        },
        true
      )
      .subscribe((response) => {
        if (response.type === "success" && response.code === 200)
          this.getCardList();
      });
  }
  markasDefault(cardDetail) {
    /* const modalRef = this.modalService.open(ModalDefaulCardComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
      animation: true,
    });
    modalRef.componentInstance.fromParent = {
      userCards: this.cards,
    };
    modalRef.componentInstance.changeCard.subscribe(
      (response) => {
        if (response) {
          this.getCardList();
        }
      },
      (reason) => {}
    ); */
    swal
      .fire({
        title: "",
        text: "Now onwards, this selected card is used for all services and subscription scheduler. Are you sure want to change card?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      })
      .then((result) => {
        if (result.value) {
          this.http
            .post(
              API_URLS.DEFAULT_CARD,
              { user_id: cardDetail.user_id, card_id: cardDetail.id },
              true
            )
            .subscribe((resp) => {
              this.getCardList();
            });
        }
      });
  }
  confirmCard() {
    this.removeCard(this.selectedCardDetail);
    this.closeModalContent();
  }
  openModalContent(content) {
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
  }
  closeModalContent() {
    this.modalService.dismissAll();
  }
}
